import { CategoryTileProps } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTile';
import { NextCategoryTileImg } from 'components/PreauthV3/NextCategoryTileImage';

const BedBath = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/BedBath.jpg';
const Brands = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Brands.jpg';
const CashFund = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/CashFunds.jpg';
const Collection =
  '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Collection.jpg';
const Experience =
  '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Experience.jpg';
const Furniture = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Furniture.jpg';
const Home = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Home.jpg';
const Kitchen = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Kitchen.jpg';
const NewArrivals =
  '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/NewArrivals.jpg';
const RegistryEssentials =
  '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/RegistryEssentials.jpg';
const Tabletop = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Tabletop.jpg';
const Weekend = '/static-preauth/images/WeddingRegistryLP/V3/CategoryTiles/Desktop/Weekend.jpg';

const weekendDesktopItem: CategoryTileProps = {
  altText: 'A man grabbing a beer from a small gray Yeti cooler.',
  imageElement: (
    <NextCategoryTileImg
      image={Weekend}
      alt="A man grabbing a beer from a small gray Yeti cooler."
    />
  ),
  linkText: 'Weekend',
  href: '/shop/category/weekend',
};

const tableTopDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Tabletop} alt="" />,
  linkText: 'Tabletop',
  href: '/shop/category/dining',
};

const registryEssentialsDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={RegistryEssentials} alt="" />,
  linkText: 'Registry Essentials',
  href: '/shop/collection/zola-registry-essentials',
};

const newArrivalsDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={NewArrivals} alt="" />,
  linkText: 'New Arrivals',
  href: '/shop/collection/new-arrivals',
};

const kitchenDesktopItem: CategoryTileProps = {
  altText:
    'Gray Le Creuset large and small dutch ovens with gold hardware, and a gray Le Creuset Signature Skillet.',
  imageElement: (
    <NextCategoryTileImg
      image={Kitchen}
      alt="Gray Le Creuset large and small dutch ovens with gold hardware, and a gray Le Creuset Signature Skillet."
    />
  ),
  linkText: 'Kitchen',
  href: '/shop/category/kitchen',
};

const homeDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Home} alt="" />,
  linkText: 'Home',
  href: '/shop/category/home',
};

const furnitureDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Furniture} alt="" />,
  linkText: 'Furniture',
  href: 'shop/category/furniture',
};

const experienceDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Experience} alt="" />,
  linkText: 'Experiences',
  href: '/shop/category/experiences',
};

const bedBathDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={BedBath} alt="" />,
  linkText: 'Bed & Bath',
  href: '/shop/category/bedding-and-bath',
};

const brandsDesktopItem: CategoryTileProps = {
  altText: 'A woman using a lilac Kitchen Aid Artisan mixer.',
  imageElement: (
    <NextCategoryTileImg image={Brands} alt="A woman using a lilac Kitchen Aid Artisan mixer." />
  ),
  linkText: 'Brands',
  href: '/shop/brands',
};

const cashFundsDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={CashFund} alt="" />,
  linkText: 'Cash Funds',
  href: '/shop/honeymoon-cash-funds',
};

const collectionDesktopItem: CategoryTileProps = {
  altText: 'A white Cuisinart coffee maker and a Breville Barista Express espresso machine.',
  imageElement: (
    <NextCategoryTileImg
      image={Collection}
      alt="A white Cuisinart coffee maker and a Breville Barista Express espresso machine."
    />
  ),
  linkText: 'Collections',
  href: '/shop/gift-collections/starter-collections',
};

export const registryCategoryItemsAlt = [
  kitchenDesktopItem,
  tableTopDesktopItem,
  bedBathDesktopItem,
  furnitureDesktopItem,
  homeDesktopItem,
  cashFundsDesktopItem,
  registryEssentialsDesktopItem,
  newArrivalsDesktopItem,
  experienceDesktopItem,
  brandsDesktopItem,
  weekendDesktopItem,
  collectionDesktopItem,
];
